import { Component, Vue, Watch } from 'vue-property-decorator'

import { library } from '@fortawesome/fontawesome-svg-core'
import {
	faTrashAlt,
	faPlusCircle,
	faExternalLinkAlt,
	faEdit,
	faPlus,
	faMinus,
} from '@fortawesome/free-solid-svg-icons'

import Loader from '@/components/Loader/index.vue'
import FieldPortal from '@/components/edit/FieldPortal/index.vue'
import MessageError from '@/components/edit/MessageError/index.vue'
import ManageArray from '@/components/edit/ManageArray/index.vue'
import MessageErrorAlert from '@/components/edit/MessageErrorAlert/index.vue'
import MessageSuccess from '@/components/edit/MessageSuccess/index.vue'
import TableTrialDetail from './TableTrialDetail/index.vue'
import Judiciary from './Judiciary/index.vue'
import Administrative from './Administrative/index.vue'

import InputPortal from '@/components/edit/InputPortal/index.vue'
import UploadReport from '@/components/edit/UploadReport/index.vue'
import ListLastReports from '@/components/edit/ListLastReports/index.vue'

import dateHelper from '@/helpers/date'

import { validationMixin } from 'vuelidate'

import Control from '@/helpers/control'
import api from '@/helpers/fetch'
import vSelect from 'vue-select'

import Diff from 'vue-jsdiff'

import { bus } from '@/main'

library.add(
	faTrashAlt,
	faPlusCircle,
	faExternalLinkAlt,
	faEdit,
	faPlus,
	faMinus,
)

Vue.component('v-select', vSelect)

@Component({
	components: {
		Loader,
		MessageError,
		MessageSuccess,
		FieldPortal,
		MessageErrorAlert,
		TableTrialDetail,
		InputPortal,
		ManageArray,
		Judiciary,
		Administrative,
		UploadReport,
		ListLastReports,
	},
	mixins: [validationMixin],
})
export default class ClientsDetail extends Vue {
	group: any | null = null
	// selectedTrialId = 0
	// loadingTrial = false

	groupInfoId: any | null = null
	saving = false
	intervalId: any = 0
	// sitDate = ''
	lastSaveDate: Date | null = null
	insert = {
		sendTo: {
			loading: false,
			name: '',
		},
	}

	users
	model = null

	totalAdded = 0
	totalRemoved = 0

	diff: null | any[] = null
	diffData: null | any

	ellipsis = '(...)'
	suppressed = '[SUPRIMIDO]'

	view: any[] = []

	success = false
	error = ''
	control = new Control()

	tabs = ['Judicial', 'Administrativo']
	activeTab = 'Judicial' // Inicia com a tab "Judicial" selecionada
	updateReportList = 0

	async mounted() {
		bus.$on('fetchDiff', this.fetchDiff)
		bus.$on('loadPDF', (tab) => {
			this.activeTab = tab
			this.loadPDF(tab)
		})
		this.$store.dispatch('saveCurrentFullPath', this.$route.fullPath)

		if (this.$route.params.clientId) {
			await this.fetchClientDetail()
		}

		this.loadHash()

		await Vue.nextTick()
		this.view = this.group.reportType
		this.loadPDF(this.activeTab)
	}

	handleError(errorMessage) {
		this.error = errorMessage
	}

	passSuccessToGrandparent(success, saving, lastSaveDate) {
		this.success = success
		this.saving = saving
		this.lastSaveDate = lastSaveDate
	}

	updateAdmReportType(value) {
		this.view = value
	}

	async fetchClientDetail() {
		this.$store.dispatch('saveCurrentFullPath', this.$route.fullPath)

		const resData = await Promise.all([
			api.get('/api/groups/' + this.$route.params.clientId),
			api.get('/api/users2'),
			api.get('/api/groups-adm/' + this.$route.params.clientId),
			api.get('/api/groups/' + this.$route.params.clientId + '/clients'),
		])

		const res = resData[0]
		const userResp = resData[1]
		const resAdm = resData[2]
		const resClients = resData[3]

		resClients.data.forEach((client) => {
			const cnpj =
				client?.CNPJOrCPF.length === 11
					? client?.CNPJOrCPF?.replace(
							/^(\d{3})(\d{3})(\d{3})(\d{2})/,
							'$1.$2.$3-$4',
						)
					: client?.CNPJOrCPF?.replace(
							/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/,
							'$1.$2.$3/$4-$5',
						)

			client.name = cnpj + ' - ' + client.name
		})

		res.data.clients = [
			{ id: null, name: 'Sem Filtro', CNPJOrCPF: null },
			...resClients.data,
		]

		if (userResp.ok) {
			this.users = userResp.data.filter((user) => {
				return user?.email.includes('locatelliadv.com.br')
			})
		}

		if (!res.ok) {
			// inform error and
			return
		}

		if (res?.data?.trials) {
			res.data.trials.forEach((trial) => {
				trial.trial.loading = false
			})
		}

		// this.group = { ...res.data }

		// Verifica se court_costs_to é uma string e tenta converter para um array
		if (typeof res.data.court_costs_to === 'string') {
			try {
				this.group = {
					...res.data,
					court_costs_to: JSON.parse(res.data.court_costs_to),
				}
			} catch (error) {
				console.error(
					'Erro ao converter court_costs_to para array',
					error,
				)
				// Se a string não for um JSON válido, converte para um array com base em vírgulas
				this.group = {
					...res.data,
					court_costs_to: res.data.court_costs_to.split(','),
				}
			}
		} else {
			this.group = { ...res.data }
		}

		//if (resAdm) {
		//this.groupInfoId = resAdm.data.administrative.id
		//}
	}

	async fetchDiff() {
		const resData = await api.get(
			'/api/diff/' + this.$route.params.clientId,
		)
		this.diffData = resData?.data

		if (
			this.diffData.currentTextReport &&
			this.diffData.lastSentTextReport
		) {
			const length1 = this.diffData.currentTextReport.length
			const length2 = this.diffData.lastSentTextReport.length

			if (length1 < 20000 && length2 < 20000) {
				this.calcDiff()
			} else {
				this.blockedDiff = true
			}
		}
	}

	calcDiff() {
		const diff = Diff.diffWords(
			this.diffData.lastSentTextReport,
			this.diffData.currentTextReport,
		)
		const result: any[] = []

		diff.forEach((part, index) => {
			const type = getType(part)

			const arrayPerLine = part?.value?.split('\n')
			const allValues: any[] = []

			arrayPerLine.forEach((a) => {
				allValues.push(a)
			})

			const afterPart = diff[index + 1]
			const afterType = getType(afterPart)
			let isBefore = false

			if (type === 'normal' && afterType !== 'normal') {
				isBefore = true
			}

			result.push({
				...part,
				value: allValues,
				isBefore,
			})
		})

		this.diff = this.finalize(result, true, true)
	}

	finalize(result, bla?, ble?) {
		const resultOutput: any[] = []

		result.forEach((res, i) => {
			const type = getType(res)
			const oldValue = res.value
			let newRes = { ...res }

			if (type === 'normal') {
				if (bla) {
					newRes = { ...res, value: this.clear(oldValue) }
				}

				if (ble) {
					newRes = { ...res, value: this.clear2(oldValue) }
				}
			} else {
				if (res.added) {
					this.totalAdded++
				}

				if (res.removed) {
					this.totalRemoved++
				}
			}

			resultOutput.push(newRes)
		})

		return resultOutput
	}

	clear(oldValue) {
		const length = oldValue.length
		const allowedIndexes: any[] = this.getAllowedIndexes(length)

		const newValue: any[] = []

		oldValue.forEach((val: string, i) => {
			const condition =
				allowedIndexes.indexOf(i.toString()) > -1 ||
				val.includes('=') ||
				val.includes('Processo n°')

			if (condition) {
				newValue.push(val)
			} else {
				newValue.push(this.suppressed)
			}
		})

		return newValue
	}

	clear2(oldValue) {
		const newValue = this.clear(oldValue)
		const filtered: any[] = []

		newValue.forEach((val, i) => {
			const prevVal = filtered[filtered.length - 1]

			if (prevVal !== undefined) {
				if (val === this.suppressed) {
					if (
						!prevVal.includes(this.suppressed) &&
						!prevVal.includes(this.ellipsis)
					) {
						filtered.push(this.ellipsis)
					}
				} else {
					filtered.push(val)
				}
			} else {
				filtered.push(val)
			}
		})

		return filtered
	}

	getAllowedIndexes(length) {
		const allowedIndexesObject = {}
		const linesToShow = Math.min(4, length)

		for (let k = 0; k < linesToShow; k++) {
			allowedIndexesObject[k] = true
		}

		for (let k = -linesToShow; k < 0; k++) {
			allowedIndexesObject[k + length] = true
		}

		return Object.keys(allowedIndexesObject)
	}

	beforeDestroy() {
		clearInterval(this.intervalId)
	}

	blockedDiff = false

	get lastSaveTimestamp() {
		if (!this.lastSaveDate) return ''

		const seconds = Math.floor(
			(new Date().getTime() - this.lastSaveDate.getTime()) / 1000,
		)
		let interval = Math.floor(seconds / 86400)
		if (interval >= 1) {
			// mais de 5 dias
			if (interval >= 5) {
				return `Salvo em ${this.lastSaveDate.toLocaleDateString('pt', {
					hour: 'numeric',
					minute: 'numeric',
					second: 'numeric',
					year: 'numeric',
					month: '2-digit',
					day: 'numeric',
				})}`
			} else {
				return `Salvo ${interval} dias atrás, em ${this.lastSaveDate.toLocaleDateString(
					'pt',
					{
						hour: 'numeric',
						minute: 'numeric',
						second: 'numeric',
						year: 'numeric',
						month: '2-digit',
						day: 'numeric',
					},
				)}`
			}
		}
		interval = Math.floor(seconds / 3600)
		if (interval >= 1) {
			return `Salvo ${interval} horas atrás, às ${this.lastSaveDate.toLocaleTimeString()}`
		}
		interval = Math.floor(seconds / 60)
		if (interval >= 1) {
			return `Salvo ${interval} minutos atrás`
		}

		return `Salvo há alguns segundos`
	}

	onInput(name, value) {
		const debouncedChange = this.control.debounce(() => {
			this.save(name, value)
		}, 1000)
		debouncedChange()
	}

	async save(name, value) {
		this.reset()
		this.saving = true

		const newGroup = {}
		newGroup[name] = value

		if (name === 'reportSendingFrom') {
			await api.put(
				'/api/groups-adm/' + parseInt(this.$route.params.clientId, 10),
				newGroup,
			)
		}

		const result = await api.put(
			'/api/groups/' + parseInt(this.$route.params.clientId, 10),
			newGroup,
		)

		this.saving = false

		if (result.ok) {
			this.success = true
			this.lastSaveDate = new Date()

			this.view = this.group.reportType
			/*
			if (this.group.reportType === 'Específico') {
				this.viewSpecific()
			} */
			//else {
			//	this.loadPDF(this.activeTab)
			//}
		} else {
			this.error = result.msg
		}
	}

	reset() {
		this.success = false
		this.error = ''
	}

	loadHash() {
		if (this.$route.hash) {
			// @ts-ignore
			const trial = this.group.trials.find(
				(trial) =>
					trial.trial.cnj.replace(/[-.]/gi, '') ===
					this.$route.hash.replace(/[#-.]/gi, ''),
			)
			// if (trial) this.openTrial(trial.trial)
		}
	}

	@Watch('$route.hash')
	onParamUpate(newParam, oldParam) {
		this.loadHash()
	}

	format(date) {
		return dateHelper.utc.format(date)
	}

	hasPortal() {
		return this.view.find((item) => item === 'Portal')
	}

	hasSpecific() {
		return this.view.find((item) => item === 'Específico')
	}

	toggleClosed(trial) {
		Vue.set(trial, 'loadingClosed', true)
	}

	loadPDF(activeTab) {
		const iframe = this.createPdf(activeTab)

		setTimeout(() => {
			const wrapperIframe: HTMLElement | null =
				document.querySelector('#wrapper-iframe') || null

			if (wrapperIframe) {
				wrapperIframe.innerHTML = ''
				wrapperIframe.appendChild(iframe)
			}
		}, 100)
	}

	createPdf(activeTab) {
		const iframe = document.createElement('iframe')
		iframe.setAttribute('class', 'iframe w-100 h-100')
		iframe.setAttribute('id', 'pdf-frame')
		iframe.setAttribute('ref', 'pdf-frame')

		let url = ''

		if (activeTab === 'Judicial') {
			const judiciary: any = this.$refs.judiciary
			url = judiciary.getPdfUrl()
		} else if (activeTab === 'Administrativo') {
			const administrative: any = this.$refs.administrative
			url = administrative.getPdfUrl()
		}

		iframe.setAttribute('src', url)

		return iframe
	}

	async switchTab(tab) {
		this.activeTab = tab
		this.updateReportList++
		await Vue.nextTick()
		if (tab === 'Judicial') {
			this.view = this.group.reportType
		}
		this.loadPDF(this.activeTab)
	}

	onUploadSuccess() {
		const listLastReportsComponent: any = this.$refs.listLastReports
		listLastReportsComponent.getReportFiles()
	}

	downloading = false
	csvHref = ''
	downloadProp = 'relatorio.csv'
	async downloadCsv() {
		this.downloading = true

		const baseUrl =
			this.activeTab === 'Administrativo'
				? '/api/relatorio-csv-adm/'
				: '/api/relatorio-csv/'

		const res = await api.get(baseUrl + this.group.id)
		const csvContent = res.data

		const encodedUri = encodeURI(csvContent)

		this.csvHref = 'data:text/csv;charset=utf-8,\uFEFF' + encodedUri

		const time = new Date().getTime() - 3 * 60 * 60 * 1000

		this.downloadProp =
			'relatorio-' +
			this.group.name.toLowerCase().replace(/ /g, '-') +
			'-' +
			new Date(time).toISOString().substring(0, 16) +
			'.csv'

		await Vue.nextTick()
		const link: any = this.$refs.csvLink

		if (link && link.click) {
			link.click()
			this.downloading = false
		}
	}
}

function getType(part) {
	if (part) {
		if (part?.removed) {
			return 'removed'
		}

		if (part?.added) {
			return 'added'
		}

		return 'normal'
	} else {
		return null
	}
}

function numeric(val) {
	if (!val) {
		return true
	}

	const regex = RegExp('^[0-9.-]*$')

	return regex.test(val)
}

function print(part, fragment, index) {
	let span: any = null
	// green for additions, red for deletions
	// grey for common parts
	const color = part.added ? 'green' : part.removed ? 'red' : 'grey'
	span = document.createElement('span')
	span.style.color = color
	span.appendChild(document.createTextNode(index + ': ' + part.value))
	fragment.appendChild(span)
}
